import React from 'react';
import PropTypes from 'prop-types';

const Details = ({ expansionPanelDetails, isCollapsed }) => (
  <div className="expansionPanelDetails" style={{ display: isCollapsed ? 'none' : 'block' }}>
    {expansionPanelDetails}
  </div>
);

Details.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  expansionPanelDetails: PropTypes.any,
  isCollapsed: PropTypes.bool.isRequired,
};
Details.defaultProps = {
  expansionPanelDetails: <div />,
};

export default Details;
